import {
  ArrowLeftIcon,
  ArrowRightIcon,
} from '@components/ShopifyViewer/SvgIcons';
import { Box } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { useEffect, useState } from 'react';
import SwipeableViews from 'react-swipeable-views';

interface ICarouselImage {
  images: string[];
  style?: CSSProperties;
  height?: string;
  handleUpdateCarouselImage?: (imageUrl: string) => void;
}

const CarouselImage: React.FC<ICarouselImage> = ({
  images,
  height,
  style,
  handleUpdateCarouselImage,
}) => {
  const total = images.length;
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (handleUpdateCarouselImage)
      handleUpdateCarouselImage(images[index] || '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images[index]]);

  return (
    <Box position="relative" textAlign="center">
      <Box
        display="flex"
        justifyContent="space-between"
        position="absolute"
        top="50%"
        width="100%"
        padding="5px"
      >
        <Box
          width="20px"
          style={{ cursor: 'pointer' }}
          zIndex={10}
          onClick={() => setIndex((index + total - 1) % total)}
        >
          {ArrowLeftIcon}
        </Box>
        <Box
          width="20px"
          style={{ cursor: 'pointer' }}
          zIndex={10}
          onClick={() => setIndex((index + 1) % total)}
        >
          {ArrowRightIcon}
        </Box>
      </Box>
      <SwipeableViews
        index={index}
        // @ts-expect-error MUI v4 types incompatible with React 18, will be fixed in MUI v5 migration
        style={{ ...style, overflow: 'hidden', backgroundColor: '#fff' }}
      >
        {images.map(image => (
          <img
            key={image}
            src={image}
            alt="Carousel"
            draggable={false}
            style={{
              height: 'auto',
              width: 'auto',
              maxHeight: height || '100%',
              maxWidth: '100%',
              padding: '10px 5px 10px 5px',
              backgroundColor: '#fff',
            }}
          />
        ))}
      </SwipeableViews>
      <Box
        display="flex"
        justifyContent="center"
        position="absolute"
        bottom="2px"
        alignItems="center"
        width="100%"
        style={{ gap: '2px' }}
      >
        {images.map((image, pIndex) => (
          <Box
            key={image}
            style={{ background: index === pIndex ? '#4C33FF' : 'white' }}
            width={index === pIndex ? '5px' : '3.67px'}
            height={index === pIndex ? '5px' : '3.67px'}
            border="0.5px solid #4C33FF"
            borderRadius="50%"
          />
        ))}
      </Box>
    </Box>
  );
};

export default CarouselImage;
